import { Checkbox } from '@mui/material';
import React, { useState, useEffect } from 'react';
import './Checkbox.module.scss';

const MLCheckbox = ({
  isChecked = false,
  labelText,
  setCheckedStatus = () => {},
  classList = '',
  isDisabled = false,
}) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleChange = (event) => {
    const value = event.target.checked;
    setChecked(value);
    setCheckedStatus(value);
  };

  return (
    <div className="flex items-center gap-2">
      <Checkbox
        className="check-large"
        checked={checked}
        onChange={handleChange}
        disabled={isDisabled}
      />
      <span className={classList}>{labelText}</span>
    </div>
  );
};

export default MLCheckbox;
